export default {"src":"https://webcdn.trailways.com/_next/static/media/line.9135537f.svg","height":1,"width":66,"blurWidth":0,"blurHeight":0};